//scroll click
jQuery(function(){
  var urlHash = location.hash;
  if(urlHash) {
    jQuery('body,html').stop().scrollTop(0);
    setTimeout(function () {
      scrollToAnker(urlHash) ;
    }, 100);
  }
  jQuery('a[href^="#"]').click(function() {
    var href= jQuery(this).attr("href");
    var hash = href == "#" || href == "" ? 'html' : href;
    scrollToAnker(hash);
    return false;
  });
  function scrollToAnker(hash) {
    var target = jQuery(hash);
    var position = target.offset().top;
        jQuery('body,html').stop().animate({scrollTop:position}, 800);
        jQuery("header").removeClass("show");
      if (window.matchMedia( "(max-width: 1024px) and (min-width: 769px)" ).matches) {
          jQuery('body,html').stop().animate({scrollTop:position}, 800);
      }
      if (window.matchMedia( "(max-width: 768px)" ).matches) {
          jQuery('body,html').stop().animate({scrollTop:position}, 800);
      }
  }
});

//scroll effect
window.onload = function() {
    scroll_effect();
    $(window).scroll(function(){
     scroll_effect();
    });
    function scroll_effect(){
     $('.effect__fade').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 100){
       $(this).addClass('effect__scroll');
      }
     });
    }
  };
  
//modal
$(function(){
    var winScrollTop;
    $('.modal__open--movie').on('click',function(){
        winScrollTop = $(window).scrollTop();
        $('.modal.movie').fadeIn();
        return false;
    });
    $('.modal__close--movie').on('click',function(){
        $('.modal.movie').fadeOut();
        $('body,html').stop().animate({scrollTop:winScrollTop}, 0);
        return false;
    });
});

//nav open/close
$(function() {
    $(".header__innner--nav").click(function() {
        $("header").toggleClass("open");
    });
  });
$(function() {
  var $target = $('.target');
  if ($target.length) {
    var height = $target.offset().top;
    $(window).on("scroll", function() {
      if ($(this).scrollTop() > height ) {
        $("header").addClass('switch');
      } else {
        $("header").removeClass('switch');
      }
    });
  }
});

//nav open/close
$(function() {
  $(".cpheader__inner--nav").click(function() {
      $("header").toggleClass("open");
  });
});

//headerbottom__inner--item
$(function() {
  $(".cpheader__inner.pc .cpheader__inner--menu a:nth-of-type(2)").mouseover(function(){
    $(".cpheader__inner.pc .cpheader__inner--menu a:nth-of-type(2)").addClass("active");
    $(".cpheader__service").addClass("active");
  });
  $(".cpheader__service").mouseover(function(){
    $(".cpheader__inner.pc .cpheader__inner--menu a:nth-of-type(2)").addClass("active");
    $(".cpheader__service").addClass("active");
  });
  $(".tab__bg").mouseover(function(){
    $(".cpheader__inner.pc .cpheader__inner--menu a:nth-of-type(2)").removeClass("active");
    $(".cpheader__service").removeClass("active");
  });
});

$(function(){
  var pos = 0;
  var headersplogo = $('.cpheader__inner.sp > .cpheader__inner--logo');

  $(window).on('scroll', function(){
    if($(this).scrollTop() < pos ){
      headersplogo.removeClass("hide");
    }else{
      headersplogo.addClass("hide");
    }
    pos = $(this).scrollTop();
  });

});

//login
$(function() {
  $(".type4__inner--form--lost").click(function() {
      $("section.type4").toggleClass("open");
  });
});

//add
$(function() {
  $(".add__btn").click(function() {
      $("section.type5").toggleClass("add");
  });
});

//edit
$(function() {
  $(".edit__btn").click(function() {
      $("section.type5").toggleClass("edit");
  });
});

//Accordion
$(function() {
  $(".type2__inner--qa--item--question").click(function() {
      $(this).parent().toggleClass("open");
  });
});

//scroll btn
$(function () {
  $("#topmember .topmember__arrow > img").click(function () {
    $("#topmember .topmember__content").animate(
      {
        scrollLeft: $("#topmember .topmember__content").scrollLeft() + 350,
      },
      300
    )
    return false
  })
})

//scroll btn
$(function () {
  $(".type2__inner--content--right").click(function () {
    $(".type2__inner--content--3row").animate(
      {
        scrollLeft: $(".type2__inner--content--3row").scrollLeft() + 350,
      },
      300
    )
    return false
  })
  $(".type2__inner--content--left").click(function () {
    $(".type2__inner--content--3row").animate(
      {
        scrollLeft: $(".type2__inner--content--3row").scrollLeft() - 350,
      },
      300
    )
    return false
  })
})

//scroll btn
$(function () {
  $(".service__event .slide .slide__right").click(function () {
    $(".service__event .slide .slide__content").animate(
      {
        scrollLeft: $(".service__event .slide .slide__content").scrollLeft() + 387,
      },
      300
    )
    return false
  })
  $(".service__event .slide .slide__left").click(function () {
    $(".service__event .slide .slide__content").animate(
      {
        scrollLeft: $(".service__event .slide .slide__content").scrollLeft() - 387,
      },
      300
    )
    return false
  })
})

//menu open/close
$(function() {
  $(".service__social_media .social_mediamenu__item > div:nth-of-type(1)").click(function() {
      $(this).parent().toggleClass("open");
  });
});

//menu open/close
$(function() {
  $(".service__social_media .social_mediaqa__item > div:nth-of-type(1)").click(function() {
      $(this).parent().toggleClass("open");
  });
});

//works
$(function() {
  $(".works .cpheading__inner--menu--item").click(function() {
      $(".works .cpheading__inner--menu--item").removeClass("active");
      $(this).addClass("active");
  });
  $(".works .cpheading__inner--menu--item.all").click(function() {
    $(".works .works__article").removeClass("media");
    $(".works .works__article").removeClass("produce");
    $(".works .works__article").removeClass("event");
    $(".works .works__article").removeClass("sns");
    $(".works .works__article").addClass("all");
  });
  $(".works .cpheading__inner--menu--item.media").click(function() {
    $(".works .works__article").removeClass("all");
    $(".works .works__article").removeClass("produce");
    $(".works .works__article").removeClass("event");
    $(".works .works__article").removeClass("sns");
    $(".works .works__article").addClass("media");
  });
  $(".works .cpheading__inner--menu--item.produce").click(function() {
    $(".works .works__article").removeClass("all");
    $(".works .works__article").removeClass("media");
    $(".works .works__article").removeClass("event");
    $(".works .works__article").removeClass("sns");
    $(".works .works__article").addClass("produce");
  });
  $(".works .cpheading__inner--menu--item.event").click(function() {
    $(".works .works__article").removeClass("all");
    $(".works .works__article").removeClass("media");
    $(".works .works__article").removeClass("produce");
    $(".works .works__article").removeClass("sns");
    $(".works .works__article").addClass("event");
  });
  $(".works .cpheading__inner--menu--item.sns").click(function() {
    $(".works .works__article").removeClass("all");
    $(".works .works__article").removeClass("media");
    $(".works .works__article").removeClass("produce");
    $(".works .works__article").removeClass("event");
    $(".works .works__article").addClass("sns");
  });
});

//animation
$(function() {
  var animItems = ['dog','1','2','3','4','5','6'];
  animItems.forEach(function(item) {
    var $target = $('.animation__item--' + item + '--target');
    if ($target.length) {
      var height = $target.offset().top;
      $(window).on("scroll", function() {
        if ($(this).scrollTop() > height) {
          $(".animation__item--" + item).addClass('fade');
        }
      });
    }
  });
});